import React, { useContext } from "react";
import {
  Accordion,
  AccordionContext,
  useAccordionToggle
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { ArticlesContext } from "../../contexts/ArticlesContext";
import { CategoriesContext } from "../../contexts/CategoriesContext";
import { Arrow } from "../Icons/Arrow";
import { Chevron } from "../Icons/Chevron";

export const FAQ: React.FC = () => {
  const categoriesContext = useContext(CategoriesContext);
  const articlesContext = useContext(ArticlesContext);

  const faqCategories = categoriesContext.faqCategories;

  return (
    <div className="faq">
      <Accordion>
        {faqCategories.map(category => (
          <div className="faq__item" key={category.id}>
            <ContextAwareToggle eventKey={`${category.id}`}>
              {category.title}
            </ContextAwareToggle>
            <Accordion.Collapse eventKey={`${category.id}`}>
              <div className="accordion__content faq__content">
                {articlesContext
                  .filteredArticlesByCategory(category)
                  .map(article => (
                    <div className="faq__link">
                      <Link to={`/article/${article.id}`}>
                        <Arrow />
                        <span>{article.subtitle}</span>
                      </Link>
                    </div>
                  ))}
              </div>
            </Accordion.Collapse>
          </div>
        ))}
      </Accordion>
    </div>
  );
};

interface ContextAwareToggleProps {
  children: any;
  eventKey: any;
  callback?: any;
}

const ContextAwareToggle: React.FC<ContextAwareToggleProps> = ({
  children,
  eventKey,
  callback
}) => {
  const currentEventKey = useContext(AccordionContext);

  const toggleItem = useAccordionToggle(
    eventKey,
    () => callback && callback(eventKey)
  );

  const isCurrentEventKey = currentEventKey === eventKey;

  return (
    <div
      className={`accordion__toggle faq__toggle ${
        isCurrentEventKey ? "accordion__toggle--open" : ""
      }`}
      onClick={toggleItem}
    >
      {children}
      <span className="accordion__toggle-icon faq__toggle-icon">
        <Chevron />
      </span>
    </div>
  );
};
